import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { PropertyFieldDefinitionInput } from '@nuso/common/types';
import { FormDialogService, DialogSaveEvent } from '../form-dialog/form-dialog.service';
import { FormDefinition } from '@nuso/forms/data-access';
import { MatDialogConfig } from '@angular/material/dialog';

@Component({
    selector: 'nuso-editable-properties-card',
    templateUrl: './editable-properties-card.component.html',
    styleUrls: ['./editable-properties-card.component.scss'],
    standalone: false
})
export class EditablePropertiesCardComponent {
  private dialog = inject(FormDialogService);


  @Input() cardTitle: string;
  @Input() fields: (string | PropertyFieldDefinitionInput)[];
  @Input() data: any;
  @Input() formDef: FormDefinition;
  @Input() config: MatDialogConfig = {
    width: '400px'
  }

  @Output() saveClicked = new EventEmitter<DialogSaveEvent<any>>();

  editClicked() {
    this.dialog.createDialog({
      formDef: this.formDef,
      title: this.cardTitle ? `Edit ${this.cardTitle}` : 'Edit',
      input: this.data
    }, this.config)
    .dialogSaving.subscribe((saving: DialogSaveEvent<any>) => {
      this.saveClicked.emit(saving);
    })
  }

}
